<template>
  <div class="user_container">
    <div class="container_top">
      {{ startDate }}到{{ endDate }}客户评价周报汇总
    </div>
    <div class="search">
      <el-select
        v-model="valueCity"
        placeholder="请选择"
        class="selectWeek"
        @change="changeCity"
      >
        <el-option
          v-for="item in optionCity"
          :key="item.id"
          :label="item.zoneName"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <!-- <div class="container_table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          type="index"
          width="60"
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column label="姓名" align="center">
          <template slot-scope="{ row }">
            <span style="color: blue" @click="toUrl(row)">{{
              row.driverName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="carBrand"
          width="100"
          label="车牌号"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="weekRank"
          width="110"
          label="周个人排名"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="weekAverageScore"
          width="110"
          label="周综合评分"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="totalRank"
          width="110"
          label="历史个人排名"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="totalAverageScore"
          width="110"
          label="历史综合评分"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="weekOrderNum" label="周接单数" align="center">
        </el-table-column>
        <el-table-column
          prop="weekToolCommentNum"
          width="110"
          label="周收获评价数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="weekGoodCommentNum"
          label="周好评数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="weekGoodCommentRadio"
          label="周好评率"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ row.weekGoodCommentRadio + "%" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="环比上周" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.weekGoodCommentRadioChainRadio > 0">
              {{ "+" + row.weekGoodCommentRadioChainRadio + "%" }}
            </span>
            <span v-else-if="row.weekGoodCommentRadioChainRadio < 0">
              {{ "-" + row.weekGoodCommentRadioChainRadio + "%" }}
            </span>
            <span v-else>
              {{ row.weekGoodCommentRadioChainRadio + "%" }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div> -->
    <div v-for="item in tableData" :key="item.id" class="box_content">
      <div class="content" @click="toUrl(item)">
        <div class="field">
          <div class="field_label">司机姓名：</div>
          <div class="field_value">{{ item.driverName }}</div>
        </div>
        <div class="field">
          <div class="field_label">车牌号：</div>
          <div class="field_value">{{ item.carBrand }}</div>
        </div>
        <div class="field">
          <div class="field_label">周接单数：</div>
          <div class="field_value">{{ item.weekOrderNum }}单</div>
        </div>
        <div class="field">
          <div class="field_label">周个人排名：</div>
          <div class="field_value">{{ item.weekRank }}</div>
        </div>
        <div class="field">
          <div class="field_label">周收获评价数：</div>
          <div class="field_value">{{ item.weekToolCommentNum }}</div>
        </div>
        <div class="field">
          <div class="field_label">周综合评分：</div>
          <div class="field_value">{{ item.weekAverageScore }}分</div>
        </div>
        <div class="field">
          <div class="field_label">周投诉数量：</div>
          <div class="field_value">{{ item.weekBadCommentNum }}条</div>
        </div>
        <div class="field">
          <div class="field_label">历史个人排名：</div>
          <div class="field_value">{{ item.totalRank }}</div>
        </div>
        <div class="field">
          <div class="field_label">周好评数：</div>
          <div class="field_value">{{ item.weekGoodCommentNum }}</div>
        </div>
        <div class="field">
          <div class="field_label">历史综合评分：</div>
          <div class="field_value">{{ item.totalAverageScore }}</div>
        </div>
        <div class="field">
          <div class="field_label">周好评率：</div>
          <div class="field_value">{{ item.weekGoodCommentRadio }}%</div>
        </div>
        <div class="field">
          <div class="field_label">环比上周：</div>
          <div
            class="field_value"
            v-if="item.weekGoodCommentRadioChainRadio > 0"
          >
            {{ "+" + item.weekGoodCommentRadioChainRadio + "%" }}
          </div>
          <div
            class="field_value"
            v-else-if="item.weekGoodCommentRadioChainRadio < 0"
          >
            {{ "-" + item.weekGoodCommentRadioChainRadio + "%" }}
          </div>
          <div class="field_value" v-else>
            {{ item.weekGoodCommentRadioChainRadio + "%" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import api from "@/apis";
import apiCar from "@/apis/car";
import api from "@/apis";

import { getToken, setToken } from "@/utils/cookie";
export default {
  name: "detail",
  props: {},
  components: {},
  data() {
    return {
      tableData: [],
      startDate: "",
      endDate: "",
      valueCity: "",
      optionCity: "",
      info: {},
    };
  },
  created() {},
  mounted() {
    const { startDate, endDate } = this.$route.query;
    this.startDate = startDate;
    this.endDate = endDate;
    //获取token
    let token = getToken();
    if (token) {
      this.getUserToken(token);
    } else {
      this.$bus.$on("processToken", (res) => {
        this.getUserToken(res);
      });
    }
  },
  methods: {
    //获取司机评价列表
    getList() {
      apiCar
        .weekCommentCountByLeader({
          startDate: this.startDate,
          endDate: this.endDate,
          zoneId: this.valueCity,
        })
        .then((data) => {
          this.tableData = data.data;
        });
    },
    //改变下拉框
    changeCity() {
      this.getList()
    },
    //获取区域
    getCity() {
      apiCar
        .queryCarZoneByPageList({
          pageSize: "999",
          page: 1,
        })
        .then((data) => {
          if (data.code == 200) {
            const zones = this.info.zones;
            if(!zones){
              return this.$message({
                type: 'warning', // success error warning
                message: '暂无区域权限',
                duration: 2000,
              })
            }
            const str = zones.split(",").map(Number).filter(Boolean); // 确保转换为数字且过滤无效值
            this.optionCity = data.data.filter((item) => str.includes(item.id));
            this.valueCity = this.optionCity[0].id;
            this.getList();
          }
        });
    },
    //获取用户信息
    getUserToken(empNo) {
      if (empNo) {
        let thisname = empNo;
        api.queryByUsername({ username: thisname }).then((data) => {
          this.info = data.data;
          setToken(empNo);
          this.getCity();
        });
      }
    },
    //跳转到司机评价详情
    toUrl(row) {
      this.$router.push({
        path: "/car/evaluate/driverWeeklyDetail",
        query: {
          startDate: this.startDate,
          endDate: this.endDate,
          driverCode: row.driverCode,
          name: row.driverName,
          zoneId: this.valueCity,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  min-height: 100vh;
  //   padding: 30px;
  margin: auto;
  font-size: 1vh;
  font-size: 26px;
  //   position: relative;
  overflow: hidden;
  .container_top {
    height: 100px;
    display: flex;
    align-items: center;
    font-size: 32px;
    padding-left: 30px;
  }
  .container_table {
    height: calc(100vh - 140px);
    width: 100%;
    background: #fff;
    padding: 30px;
  }
  .box_content {
    margin: 0 30px;
  }
  .content {
    display: flex;
    align-content: center;
    justify-content: space-between;
    flex-wrap: wrap;
    background: #fff;
    border-radius: 20px;
    padding: 30px 30px 20px;
    margin-bottom: 30px;
    font-size: 28px;
    .field {
      width: 50%;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .field_label {
        color: rgba(102, 102, 102, 1);
      }
      .field_value {
      }
    }
    .field_width {
      width: 100%;
    }
  }
}

::v-deep {
  thead .el-table__cell {
    font-size: 26px;
    background: rgba(247, 249, 250, 1);
    font-weight: none;
  }
  .el-table .cell {
    font-size: 26px;
    line-height: 60px;
    color: #000;
  }
}
::v-deep {
  .search{
    padding-left: 30px;
    margin-bottom: 30px;
  }
  .el-input__inner {
    height: 80px !important;
    border-radius: 12px !important;
    font-size: 28px;
    width: 200px;
  }
}
</style>
